import { css } from 'lit';
export const dinapsisLateralSliderPanel = css `
/* width */
::-webkit-scrollbar {
  width: 8px;
  border-radius: 4px;
  height: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #fff;
  border-bottom-right-radius: 51px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #979797;
  border-radius: 12px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #979797;
}
.active {
  white-space: nowrap;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: #fff;
  -webkit-transition: linear width 200ms;
  -moz-transition: linear width 200ms;
  -o-transition: linear width 200ms;
  transition: linear width 200ms;
  box-shadow: 0 2px 11px 0 rgba(109, 109, 109, 0.5);
}
.hide {
  background-color: #fff;
  white-space: nowrap;
  overflow: hidden;
  -webkit-transition: linear width 200ms;
  -moz-transition: linear width 200ms;
  -o-transition: linear width 200ms;
  transition: linear width 200ms, height 0ms 200ms;
  box-shadow: 0 2px 11px 0 rgba(109, 109, 109, 0.5);
}

.left-panel {
  display: flex;
  position: fixed;
}
.left-panel-active {
  display: flex;
  position: fixed;
}
.right-panel {
  display: flex;
  position: fixed;
  right: 0px;
}
.right-panel-active {
  right: 0px;
  display: flex;
  position: fixed;
}
.left-panel,
.left-panel-active,
.right-panel,
.right-panel-active {
  z-index: 1900
}
.panel-button {
  height: 42px;
  position:absolute;
  top: 0;
  transition: linear all 200ms;
  &--right {
    right: 72px;
  }
}
`;
//# sourceMappingURL=dinapsis-lateral-slider-panel-style.js.map